{
  "financingNoAccessWarning": "Du har ikkje dei nødvendege rettigheitene. I dykka klynga kan følgende personar sjå utbetalingsanmodning:",
  "sendPaymentRequestLink": "Send inn utbetalingsannmodning"
}
